export default "__VITE_ASSET__DFPEo5AK__"